import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a 1.8 x 0.7 x 1.0 fast-food service counter on 2x1
// tiles: warm-white front facing the customer at +Z, grey worktop at 1.0 and
// a small register block with a screen on top.
const CARCASS = "#e8e4dc";
const FRONT = "#efece6";
const WORKTOP = "#d8d5cf";
const BLACK = "#2e2e30";
const SCREEN = "#8a9aa8";

export const serviceCounter = defineModel({
  id: "service-counter",
  batchId: "modern",
  name: "Service counter",
  tags: ["modern", "interior", "furniture", "restaurant", "counter", "service"],
  summary: "A fast-food service counter with a register and customer screen.",
  tiles: { w: 2, h: 1 },
  footprint: 1.3,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(1.7, 0.08, 0.52), color: BLACK, position: [0, 0.04, -0.03] },
      // counter body
      { geometry: new THREE.BoxGeometry(1.8, 0.87, 0.58), color: CARCASS, position: [0, 0.515, -0.03] },
      // warm-white front panel facing the customer (+Z)
      { geometry: new THREE.BoxGeometry(1.8, 0.82, 0.06), color: FRONT, position: [0, 0.54, 0.29] },
      // worktop (top surface at 1.0, slight overhang)
      { geometry: new THREE.BoxGeometry(1.8, 0.05, 0.7), color: WORKTOP, position: [0, 0.975, 0] },
      // register block on top
      { geometry: new THREE.BoxGeometry(0.32, 0.14, 0.26), color: BLACK, position: [0.45, 1.07, -0.05] },
      // register screen tilted toward the customer (+Z)
      { geometry: new THREE.BoxGeometry(0.28, 0.22, 0.02), color: SCREEN, position: [0.45, 1.25, 0.02], rotation: [-0.25, 0, 0] },
      // screen stand
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.04), color: BLACK, position: [0.45, 1.17, -0.02] },
    ];
  },
  animations: [],
});
